import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Subaward: A subaward is a portion of the primary award provided to a subrecipient to support a project, requiring a contract that specifies terms and conditions and includes compliance monitoring activities.',
    name: 'Subawards',
    partialId: PartialId.Standard.create('subawards'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
